import { Component, ElementRef, inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { InscricaoCabecaChaveDto } from '@models/clash/clash-dto';

@Component({
  selector: 'sigecom-clash-box',
  template: `

  <div
  #div
  class="absolute w-[120px] h-[50px] overflow-hidden text-center leading-[50px] rounded-lg shadow-md group cursor-pointer"
  [ngClass]="ngClass"
  (mouseenter)="handleMouseEnter(div)"
  (mouseleave)="showPopup = false">
    <div *ngIf="bye" class="absolute -top-1 text-xs -left-4 h-6 border- text-center text-white w-14 rotate-[-37deg] bg-blue-800 py-2">BYE</div>
    <div *ngIf="isHead" class="absolute text-sm top-1 right-1">🔑</div>
    {{ name }}
  </div>
  <div
  #popup
  *ngIf="showPopup && inscricao"
  class="absolute bg-white text-black text-xs p-2 rounded-lg shadow-md h-fit w-44 z-10 items-center justify-center text-center flex flex-col"
  [ngClass]="handleMouseEnter(div)">
    <div class="text-blue-800 text-sm font-bold">{{ name }}</div>
    <div class="text-gray-500 flex flex-row gap-0.5">
      <div class="text-blue-800">
        {{ 'Nº de inscrição: ' }}
      </div>
      {{ inscricao }}
    </div>
    <div class="text-gray-500 flex flex-row gap-0.5">
      <div class="text-blue-800">
        {{ 'Cabeça de chave: ' }}
      </div>
      {{ isHead ? 'Sim' : 'Não' }}
    </div>
  </div>
  `,
})
export class ClashBoxComponent implements OnInit {

  @Input() won?: boolean = false;
  @Input() bye?: boolean = false;
  @Input() isHead?: boolean = false;
  @Input() inscricao?: InscricaoCabecaChaveDto;
  @Input() name: string = 'NULL';


  @ViewChild('boxRef', { static: true }) boxRef!: ElementRef;

  ngClass: string = '';
  showPopup: boolean = false;;

  renderer = inject(Renderer2);

  ngOnInit(): void {
    this.setBracketType();
  }

  setBracketType(): void {
    this.ngClass = this.won
      ? 'bg-[#31920F] text-white'
      : 'bg-white text-[#787878] border-[#787878] border-2';
  }

  handleMouseEnter(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;

    this.showPopup = true;

    let str = '';


    if (rect.top < windowHeight*2/3) {
      str = "top-14";
    } else {
      str = "bottom-14";
    }

    if (rect.left > windowWidth*2/3){
      str = `${str} -left-28`;
    } else {
      str = `${str} left-28`;
    }
    return str;
  }
}
